import React from 'react';
 
export function ItemIndex(props) {
  const item = props.item
  
  return (
    <li className='item-edit'>
      <p className='item-edit__name'>{item}</p>
     <button type='button' className='gg-delete item-edit__button' onClick={()=>props.handleDelete(item)}/>
    </li>
  )
}